<template>
    <div id="contact-page-container">
        <div id="contact">
            <h1 style="text-align: center; color: rgba(245, 245, 245);">
                {{ $t('contactPage.contact') }}
                <hr>
            </h1>
            <div id="info-container">
                <div class="info-div-group">
                    <div class="icon">
                        <i class="fa-solid fa-location-dot fa-3x"></i>
                    </div>
                    <div class="sub-info-div-group">
                        <p>
                            Maslak/Istanbul
                        </p>
                    </div>
                </div>
                <div class="info-div-group">
                    <div class="icon">
                        <i class="fa-brands fa-instagram fa-3x"></i>
                    </div>
                    <div class="sub-info-div-group">
                        <p>
                            <a href="https://www.instagram.com/kaynakcan/" target="_blank">@kaynakcan</a>
                            <br>
                            <a href="https://www.instagram.com/serdarkaynak_artworks/" target="_blank">@serdarkaynak_artworks</a> 
                        </p>
                    </div>
                </div>
                <div class="info-div-group">
                    <div class="icon">
                        <i class="fa-solid fa-envelope fa-3x"></i>
                    </div>
                    <div class="sub-info-div-group">
                        <p>
                            <a href="mailto:info@serdarkaynak.com">info@serdarkaynak.com</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

</script>

<style scoped>
#contact-page-container{
    width: 100vw;
    height: 100vh;

    background-image: url("../assets/images/80.webp");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    overflow: scroll;
    
    display: flex;
    flex-direction: column;
    align-items: center;
}

#contact{
    margin: auto;
    margin-top: 1%;
    margin-bottom: 2%;
    background-color: rgba(37, 37, 35, 0.9);
    border-radius: 1%;
    padding: 1%;
    width: 80%;
    height: 70%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

#info-container{
    display: flex;
    justify-content: center;
    margin-top: 5%;
}
#info-container div{
    color: rgba(245, 245, 245);
    margin-left: 5%;
    margin-bottom: 3%;
}

.icon{
    align-self: center;
}

.info-div-group{
    display: flex;
    width: 350px;
}

.sub-info-div-group{
    display: flex;
    flex-direction: column;
    justify-content: center;
}

p{
    font-size: 18px;
}

a{
    color: rgba(245, 245, 245);
    text-decoration: underline;
}

@media (max-width: 768px) {
    #contact{
        margin-top: 3%;
        width: 90%;
        border-radius: 0.5%;
    }

    #info-container{
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .icon{
        width: 50px;
    }
}
</style>